export default "__VITE_ASSET__BsDeHrwf__"